import type { ReactNode } from 'react';

type ChipKind = 'good' | 'bad' | 'warn' | 'accent';

interface ChipProps {
  kind?: ChipKind;
  outline?: boolean;
  on?: boolean;
  onClick?: () => void;
  children: ReactNode;
  className?: string;
}

const solidClasses: Record<ChipKind, string> = {
  good: 'bg-[var(--color-good-bg)] text-[var(--color-good)]',
  bad: 'bg-[var(--color-bad-bg)] text-[var(--color-bad)]',
  warn: 'bg-[var(--color-warn-bg)] text-[var(--color-warn)]',
  accent: 'bg-[var(--color-accent-soft)] text-[var(--color-accent-ink)]',
};

const outlineClasses: Record<ChipKind, string> = {
  good: 'border border-[var(--color-good)] text-[var(--color-good)] bg-transparent',
  bad: 'border border-[var(--color-bad)] text-[var(--color-bad)] bg-transparent',
  warn: 'border border-[var(--color-warn)] text-[var(--color-warn)] bg-transparent',
  accent: 'border border-[var(--color-accent)] text-[var(--color-accent-ink)] bg-transparent',
};

export const Chip = ({
  kind = 'accent',
  outline = false,
  on,
  onClick,
  children,
  className = '',
}: ChipProps) => {
  const visual = outline ? outlineClasses[kind] : solidClasses[kind];
  const interactive = onClick ? 'cursor-pointer' : '';
  const active = on ? 'ring-2 ring-[var(--color-accent)]' : '';

  const Tag = onClick ? 'button' : 'span';

  return (
    <Tag
      className={
        `inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ` +
        `${visual} ${interactive} ${active} ${className}`
      }
      onClick={onClick}
      type={onClick ? 'button' : undefined}
    >
      {children}
    </Tag>
  );
};
